export default "__VITE_ASSET__BCruGqFu__"